import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SeeAllContainer = styled(Box)(({ theme }) => ({
  height: '99%',
  backgroundColor: '#FFF',
  display: 'inline-flex',
  whiteSpace: 'nowrap',
  flexDirection: 'column',
  border: `${theme.spacing(0.125)} solid ${theme.palette.grey[200]}`,
  borderRadius: theme.spacing(2),
}));

export const SeeAllWrapperContainer = styled(Box)(({ theme }) => ({
  width: theme.spacing(13.5),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
}));

export const SeeAllInnerWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const SeeAllText = styled(Box)(({ theme }) => ({
  fontSize: theme.spacing(2),
  lineHeight: theme.spacing(3),
  marginTop: theme.spacing(1),
}));

export const CircularButton = styled(Box)(({ theme }) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  borderRadius: '50%',
  border: `${theme.spacing(0.125)} solid ${theme.palette.grey[100]}`,
  backgroundColor: '#FFF',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 1,
  position: 'absolute',
  top: 0,
  bottom: 0,
  margin: 'auto',
  boxShadow: `0 0 ${theme.spacing(3.333)} 0 rgba(0, 0, 0, 0.24)`,
  [theme.breakpoints.down('sm')]: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

export const RightCircularArrowButton = styled(CircularButton)(({ theme }) => ({
  pointerEvents: 'auto',
  right: -20,
  position: 'relative',
  left: 0,
  width: theme.spacing(7),
  height: theme.spacing(7),
  display: 'flex',
}));
